import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { PACKAGE_NAME, TEAM } from '../../common/constants';
import type {
	AvatarResponseObject,
	GetAvatarsPathParams,
	GetAvatarsResponse,
	PriorityAvatar,
	RefinedFetchError,
} from '../../common/types';
import { refineFetchError } from '../utils';
import { refineGetAvatarsResponse } from './utils';

export const getAvatars = async (
	getAvatarsPathParams: GetAvatarsPathParams,
): Promise<GetAvatarsResponse> => {
	try {
		const response: unknown = await fetchJson(
			`/rest/api/3/universal_avatar/type/${getAvatarsPathParams.type}/owner/${getAvatarsPathParams.entityId}`,
			{
				method: 'GET',
			},
		);

		return refineGetAvatarsResponse(response);
	} catch (error) {
		const fetchError: RefinedFetchError | undefined = refineFetchError(error);
		fireErrorAnalytics({
			error: fetchError
				? new Error(
						`get avatar failed with status code ${fetchError.statusCode}, traceId ${fetchError.traceId} and message ${fetchError.message}`,
					)
				: new Error(`get avatar failed with error ${error}`),
			meta: {
				id: 'getPriorityAvatar',
				packageName: PACKAGE_NAME,
				teamName: TEAM,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

export const fetchAndMapPriorityAvatars = async (
	accountId: string | null,
): Promise<PriorityAvatar[]> => {
	if (!accountId) throw new Error('No account ID');

	const response = await getAvatars({ type: 'priority', entityId: accountId });

	const responseAvatars: PriorityAvatar[] = [...response.system, ...response.custom].map(
		(avatar: AvatarResponseObject) => ({
			id: avatar.id,
			dataURI: avatar.urls['24x24'],
		}),
	);

	return responseAvatars;
};
